
import Icon from 'vux/src/components/icon/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import InlineLoading from 'vux/src/components/inline-loading/index.vue'

import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import LessionChoose from "@/components/lessionChoose";
import Lession from "@/components/Lession";
import Bottom from "@/components/bottom";
import { staticHost } from "../common/js/config";
import {
getCourseType,
getCollegeProTypeCourse,
getHomeBanner,
getHotList
} from "../api/home";

import { mapGetters } from "vuex";
export default {
name: "HomePage",
components: {
Icon,
XInput,
Tab,
TabItem,
swiper,
swiperSlide,
LessionChoose,
Lession,
Bottom,
InlineLoading
},
data() {
return {
homeData: null,
selectindex: 0,
classData: {
live: null,
boutique: null,
experience: null
},
staticHost,
bannerData: null,
lock: false,
swiperOption: {
pagination: {
el: ".swiper-pagination1",
clickable: true,
type: "bullets"
},
autoplay: {
delay: 4000,
stopOnLastSlide: false,
/* 触摸滑动后是否继续轮播 */
disableOnInteraction: false
},
loop: false
},
swiperOptionNew: {
slidesPerView: 2,
loop: false
},
swiperOptionShow: {
pagination: {
el: ".swiper-pagination2",
clickable: true,
type: "bullets"
},
autoplay: {
delay: 4000,
stopOnLastSlide: false,
/* 触摸滑动后是否继续轮播 */
disableOnInteraction: false
},
loop: true
},
searchVal: "",
placeholder: "请输入您要搜索的内容...",


hotLessionList: [],
currentPage: 1,
pageSize: 10,
total: 0,
loadingHot: false,
busy: false,
swiperImgStyle: {
"position": "absolute",
"height": "100%",
"top": "0",
"left": "50%",
"transform": "translate(-50%, 0)",
}
};
},
computed: {
computedTop() {
let recalc = function() {
var clientWidth = document.documentElement.clientWidth;
if (!clientWidth) return 0;
var val = Number(200 * (clientWidth / 750));
val = val > 200 ? 200 : val;
return val * 0.47;
};
let top = 44 + recalc() - 5;
return top + "px";

},
...mapGetters(["college"])
},
watch: {
busy(newval, oldval) {
if (newval) {
this.currentPage++;
this.getHotList();
}
}
},
mounted() {
console.log(this.homeData);
this.routerChange();
this.getHotList()

},
methods: {
routerChange() {
getCourseType({
collegeId: this.college.id
}).then(res => {
console.log(res);
if (res.success) {
this.homeData = res.entity;

this.homeData.forEach((item, index) => {
if (index <= 2) {
this._getClassData(item, index);
}
});
}
});

getHomeBanner({
college_id: 0
}).then(res => {
if (res.success) {
this.bannerData = res.entity;
this.$nextTick(()=>{
let arr = this.$refs.swiperImg
arr.forEach(item=>{
if((item.clientWidth/item.clientHeight) > 388/188) {
let imgDom = item
imgDom.setAttribute("class",'editImg')
}
})

})
}
});
},
_getClassData(item, index) {
getCollegeProTypeCourse({
collegeId: 0,
websiteCourseId: item.id
}).then(res => {
if (res.success) {
if (index == 0) {
this.classData.live = res.entity;
} else if (index == 1) {
this.classData.boutique = res.entity;
} else if (index == 2) {
this.classData.experience = res.entity;
}

}
});
},
clickRouter(val) {

if (val.skipType == "LINK") {
if (val.previewUrl) {
window.open(val.previewUrl, "_self");
}
return;
}











let json = {
courseid: val.courseId || val.id
};
if (val.topic_type == 1) {
json.topic_type = 1;
}
this.$router.push({
path: "/LessionDetail",
query: json
});
},
clickTab(index) {
if (this.lock) {
return;
}
this.selectindex = index;
this.lock = true;
let commonParent = this.$refs.commonparent;
let classItem = document.querySelectorAll(".commonclassitem"); 

let top = classItem[index].offsetTop - 10;
commonParent.scrollTo({
top,
behavior: "instant"
});
this.timer = setTimeout(() => {
this.lock = false;
clearTimeout(this.timer);
}, 300);
if (!commonParent.scrollTo) {
commonParent.scrollTop = top;
}
},
scrollTo(e) {
if (this.lock) {
return;
}
if (!e) {
return;
}
var scrollTop = e.target.scrollTop;
var arr = document.querySelectorAll(".commonclassitem"); 

for (var i = 0; i < arr.length; i++) {

if (scrollTop + 30 > arr[i].offsetTop) {
this.selectindex = i;
}
}

this.scrollEvent(e)
},
getHotList() {
let data = {

collegeId: 0,
currentPage: this.currentPage,
pageSize: this.pageSize
};
getHotList(data).then(res => {

if (res.entity.courseList && res.entity.courseList.length) {
this.hotLessionList = this.hotLessionList.concat(
res.entity.courseList
);
this.total = res.entity.page.totalResultSize;
}
this.busy = false;
this.loadingHot = false;
});
},
scrollEvent(e) {

if (
e.target.scrollTop + e.target.offsetHeight >=
e.target.scrollHeight - 10
) {
if(this.total> this.hotLessionList.length) {
this.loadingHot = true
this.busy = true
}
}
},

goDetail(val) {
this.$router.push({
path: "/LessionDetail",
query: {
courseid: val
}
});
},
}
};



// WEBPACK FOOTER //
// ./src/page/HomePage.vue